import React from 'react';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { AppBar, Box, Button, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import AccountCircle from '@mui/icons-material/AccountCircle';

import { userState } from '../atoms/States';
import logo from '../logo.svg';
import AxlDrawer from './Drawer';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {},
  username: {
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    marginLeft: 10,
  },
  secondAppBar: {
    height: 50,
    position: 'relative',
  },
  link: {
    marginLeft: 30,
    fontFamily: 'AvenirNext',
    fontSize: 18,
    textDecoration: 'none',
    padding: '10px 30px',
    color: '#fff',
    '&.active': {
      borderBottom: '3px solid #fff',
      fontWeight: 'bold',
      color: '#f4f4f4',
    },
  },
  button: {
    textTransform: 'inherit',
  },
}));

export default function Header(props) {
  const user = useRecoilValue(userState);

  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    window.location.href = `${process.env.REACT_APP_OAUTH_URL}/login?logout=true&next=${encodeURI(window.location.href)}`;
  };

  return (
    <div className={classes.root}>
      <AppBar color="default" position="static">
        <Toolbar>
          <AxlDrawer />
          <Box>
            <Link to={'/'}>
              <img alt="Jitsu logo" height="40px" src={logo} />
            </Link>
          </Box>
          <Typography variant="h6" className={classes.title}>
            DASHBOARD
          </Typography>
          {user.user && (
            <div>
              <Button
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                classes={{ root: classes.button }}
                onClick={handleMenu}
                color="inherit"
                disableRipple
                disableElevation
                startIcon={<AccountCircle />}
              >
                <span className={classes.username}>{user.user.name}</span>
              </Button>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
